import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import CarCard from "./CarCard";

export default function CarGrid({ cars = [], limit }) {
  const list = limit ? cars.slice(0, limit) : cars;
  return (
    <section id="auto" className="cm-reveal py-20 lg:py-28">
      <div className="mx-auto max-w-[1360px] px-6 lg:px-10">
        <div className="mb-12 flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <div>
            <p className="label-mono mb-5">Auto disponibili</p>
            <h2 className="h-display text-[clamp(2rem,4.2vw,3.4rem)]">
              Ti presentiamo
              <br />
              la nostra selezione.
            </h2>
            <p className="mt-4 max-w-md text-[0.95rem] text-[#7a7a72]">
              Auto di prima immatricolazione italiana. Utilizzate prevalentemente
              a Torino/Piemonte.
            </p>
          </div>
          <Link
            to="/auto"
            className="inline-flex items-center gap-2 self-start rounded-full border border-[var(--cm-line)] px-5 py-3 text-[0.88rem] font-medium transition-all duration-200 hover:border-[var(--cm-ink)] sm:self-end"
          >
            Vedi tutte le auto
            <ArrowRight size={16} />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((car) => (
            <CarCard key={car.id} car={car} />
          ))}
        </div>
      </div>
    </section>
  );
}
